import React from 'react';
import { useIcons } from '../../hooks/icons';

interface IProps {
    icon: string;
    className?: string;
    size?: number,
    fill?: string;
}

export const ToroLearnIcon = ({
    icon,
    className,
    size = 32,
    fill = '#FFF',
}: IProps): JSX.Element => {

    const { iconsUrl } = useIcons();

    return (
        !iconsUrl
            ? <span></span>
            : <svg
                width={size + 10}
                height={size}
                className={className}
                aria-hidden="true"
                fill={fill}
                style={{ color: fill }}>
                <use
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    xlinkHref={`${iconsUrl}#${icon}`}
                >
                </use>
            </svg>
    );

};
